import styles from '../styles/Color.module.scss'
import { NextPage } from 'next';
import { Button, Card, Col, message, Row, Tooltip, Typography } from 'antd';
import React, { useState } from 'react';
import Link from 'next/link';
import { CodeDownload, Download, Like } from '@icon-park/react';
import {
    LoadingOutlined,
} from '@ant-design/icons';
import { http } from '../../utils/api'
import { colorLike, getGradualPng } from '../../constants/api';
import { Item } from '../../@types/color';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { domain, title } from '../../constants/heads';
import { useSelector } from 'react-redux';
import { State } from '../../@types/reducer';
const { Paragraph } = Typography;

type Props = {
    item: Item
    imgUrl: string | string[]
    max: boolean | undefined
};
const Gradual: NextPage<Props> = ({ item, max }) => {
    const { isXs, isSm, isMd, isXxl } = useSelector((state: State) => state.responsive)
    const { like_status } = item
    const [loading, setLoading] = useState(false);
    const [likeStatus, setLikeStatus] = useState(like_status)
    const [like, setLike] = useState(item.like)

    const likeFun = async () => {
        let res: any = await http(colorLike, { id: item._id })
        if (res.code == 200) {
            if (res.data.num == 1) {
                setLike(like + 1)
                setLikeStatus(true)
            } else {
                setLike(like - 1)
                setLikeStatus(false)
            }
        }
    }

    const DownloadPng = async () => {
        setLoading(true)
        let res = await http(getGradualPng, { id: item._id })
        const a = document.createElement("a");
        a.href = res.data.url; //图片地址
        a.download = `${title}_${domain}_${new Date().getTime()}.png`; //图片名及格式
        document.body.appendChild(a);
        a.target = '_new';
        a.click();
        setLoading(false)
    }

    return (
        <Card className={styles.gradual} bodyStyle={max ? { height: isXs?'320px':'480px' } : {}} bordered={false}>
            <Row style={{ paddingBottom:'10px'}}>
                <Col span={18} style={{ fontSize: '12px' }}>
                    <Paragraph style={{ width: '100%', marginBottom: 0 }} ellipsis={true}>
                        {
                            item.colors.map((v, k) => (
                                <Tooltip key={k} placement="top" title='复制色值'>
                                    <CopyToClipboard text={v}
                                        onCopy={() => { message.success('复制成功') }}>
                                        <span>{item.colors.length > k + 1 ? v + ' → ' : v}</span>
                                    </CopyToClipboard>
                                </Tooltip>
                            ))
                        }
                    </Paragraph>
                </Col>
                <Col span={6} style={{ textAlign: 'right' }}>
                    <Tooltip placement="top" title='复制代码'>
                        <CopyToClipboard text={'background-image:' + item.style[0].backgroundImage}
                            onCopy={() => { message.success('复制成功') }}>
                            <CodeDownload theme="outline" size="20" fill="#999" strokeWidth={3} />
                        </CopyToClipboard>
                    </Tooltip>
                    &nbsp;
                    &nbsp;
                    <Tooltip placement="top" title='下载PNG'>{loading ? <LoadingOutlined /> : <Download onClick={() => { DownloadPng() }} theme="outline" size="20" fill="#999" strokeWidth={3} />}</Tooltip>
                </Col>
            </Row>
            {max ?
                <a style={{ backgroundImage: item.style[0].backgroundImage, borderRadius: '8px' }}>
                </a>
                : <Link href={`/color/${item._id}`}>
                    <a style={{ backgroundImage: item.style[0].backgroundImage }} target="_blank">
                    </a>
                </Link>}
            <Row style={{ paddingTop: '10px' }}>
                <Col span={12}>
                    <Button onClick={likeFun} shape="round" icon={<Like theme={likeStatus ? "filled" : "outline"} size="14" fill={likeStatus ? '#ffdf29' : "#d9d9d9"} />} size="small">
                        &nbsp; {like}
                    </Button>
                </Col>
                <Col span={12} style={{ textAlign: 'right' }}>
                    {item.date}
                </Col>
            </Row>
        </Card>
    )
}

export default Gradual